import React, { useState, useEffect } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import {
  Tabs,
  Tab,
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { Page, AppBar, ScreenLoader } from 'components';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { capitalize } from 'lodash';
import { ru } from 'locale';
import { anketsStore, casesStore } from 'stores';
import { amountCountFormatter } from 'utils/formatters';
import CaseList from './components/CaseList';
import { tabs, sides } from './CasesScreen.mock';
import useStyles from './CasesScreen.styles';

const CasesScreen = observer(() => {
  const [activeTab, setActiveTab] = useState(tabs[0].value);
  const history = useHistory();
  const { path } = useRouteMatch();
  const classes = useStyles();
  const { fetchState, cases } = casesStore;
  const courtStatistics = cases[activeTab];

  useEffect(
    () =>
      autorun(() => {
        casesStore.getCases(anketsStore.anketId);
      }),
    [],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const handleTabChange = (event, tabId) => {
    setActiveTab(tabId);
  };

  const handleItemSelect = id => {
    const caseNumber = encodeURIComponent(id);
    const url = `${path}/${caseNumber}`;

    history.push(url);
  };

  const a11yProps = id => {
    return {
      id,
      value: id,
      'aria-controls': `case-tabpanel-${id}`,
    };
  };

  const renderTabs = () => {
    return (
      <Tabs value={activeTab} onChange={handleTabChange} aria-label={ru.casesState}>
        {tabs.map(tab => (
          <Tab key={tab.value} label={tab.label} {...a11yProps(tab.value)} />
        ))}
      </Tabs>
    );
  };

  const renderCourtStatistics = () => {
    return sides.map(side => {
      const { label, value } = side;
      const items = courtStatistics[value];
      const keyPostfix = capitalize(value.slice(0, value.length - 1));
      const amountRaw = courtStatistics[`amountAs${keyPostfix}`];
      const amount = amountCountFormatter(amountRaw);
      const count = courtStatistics[`countAs${keyPostfix}`];
      const hasCases = count !== 0;

      return (
        <ExpansionPanel key={value}>
          <ExpansionPanelSummary
            id={`${value}-header`}
            aria-controls={`${value}-content`}
            expandIcon={hasCases ? <ExpandMoreIcon /> : null}
            classes={{
              root: classes.panelSummary,
            }}
          >
            <Grid container justify="space-between">
              <Typography component="span" className={classes.heading}>
                {label}
              </Typography>
              <Typography component="span" className={classes.heading}>
                {`${amount} (${count})`}
              </Typography>
            </Grid>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails
            classes={{
              root: classes.panelDetails,
            }}
          >
            <CaseList cases={items} onItemSelect={handleItemSelect} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      );
    });
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <AppBar
          title={cases.debtorName}
          onNavButtonClick={handleBackClick}
          additionalSlot={renderTabs()}
        />
        {fetchState === 'pending' && <ScreenLoader />}

        <Grid container item direction="column">
          {fetchState === 'fulfilled' && renderCourtStatistics()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default CasesScreen;
